<app-action-button
  (addEvent)="create()"
  (deleteEvent)="openConfirm($event)"
  [isDeleteAction]="isDeleteAction"
  [hidden]="!authorizationService.canCreateOIDCIssuer()"
  >
</app-action-button>

@if (isLoading) {
  <app-loading-indicator
    [isLoading]="isLoading"
    class="load-indicator"
    id="oidcIssuersPage"
  ></app-loading-indicator>
}

<div class="area data-table" id="ItemsArea">
  <app-noitems
    (clickEmit)="create()"
    [image]="'No_Posture'"
    [isEmpty]="showNoData"
    [typeName]="'Oidc Issuers'"
  ></app-noitems>

  @if (filterApplied || (oidcIssuers.length > 0 && !isLoading) || filterHasChanged || changedPage) {
    <app-data-table
      [tableId]="'oidc-issuers'"
      [columnDefinitions]="columnDefs"
      [columnFilters]="columnFilters"
      [deleteItem]="deleteSingleItem.bind(this)"
      [filterChanged]="filterChanged.bind(this)"
      [openItem]="open.bind(this)"
      [rowData]="oidcIssuers"
      [toggleAll]="toggleAll.bind(this)"
      [toggleItem]="toggle.bind(this)"
      [value]="oidc-issuers"
      >
    </app-data-table>
  }
</div>
